<template>
  <div style="width: 100%">
  <svg
    :style="svgStyle"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1440 320"
    preserveAspectRatio="none"
  >
    <path
      :fill="computedColor"
      fill-opacity="1"
      :d="pathD"
      />
      <!-- d="M0,64L120,96C240,128,480,192,720,229.3C960,267,1200,277,1320,282.7L1440,288L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z" -->
  </svg>
  </div>
</template>

<script>
export default {
  name: "mainRoot",

  props: {
    color: {
      type: String,
      default: null
    },
    height: {
      type: [String, Number],
      default: 120
    },
    inverted: {
      type: Boolean,
      default: false
    },
    negative: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    pathD() {
    if (this.negative) {
      return "M1440 320C860 320 680 320 0 0V320H1440Z"
    }

    return "M0,64L120,96C240,128,480,192,720,229.3C960,267,1200,277,1320,282.7L1440,288L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"
  },
    computedColor() {
      return this.color || "rgb(var(--v-theme-background))"
    },

    svgStyle() {
      return {
        width: "100%",
        height: typeof this.height === "number" ? `${this.height}px` : this.height,
        display: "block",
        'margin-top': "-18px",
        transform: this.inverted ? "rotate(180deg)" : "none",
      }
    }
  }
}
</script>